export default "__VITE_ASSET__007c1eb7__"